import type { BaseEntity } from './BaseEntity';
import type { Product } from './Product';
import type { Contact } from './Contact';

export interface Customer extends BaseEntity {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  contactId?: number | null;
  contact?: Contact;
  products?: Product[];
  bulkPricingProducts?: Product[];
}

type ValidationResult = { issues: { message: string; path: (keyof Customer)[] }[] };

export function validate(vendor: Partial<Customer>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!vendor.name) {
    issues = [...issues, { message: 'Name is required', path: ['name'] }];
  }

  if (!vendor.address) {
    issues = [...issues, { message: 'Address is required', path: ['address'] }];
  }

  if (!vendor.city) {
    issues = [...issues, { message: 'City is required', path: ['city'] }];
  }

  if (!vendor.state) {
    issues = [...issues, { message: 'State is required', path: ['state'] }];
  }

  if (!vendor.zip) {
    issues = [...issues, { message: 'Zip is required', path: ['zip'] }];
  }

  return { issues };
}